import type { LocalChartRepository } from './localPersistence.js';
import {
  buildLocalChartPrivateBackup,
  buildLocalChartRedactedShare,
  type LocalChartPrivateBackupFile,
  type LocalChartRedactedShareFile,
} from './localChartTransfer.js';
import type { ResultActionId } from './resultActionsPresentation.js';

export type ProductionExportActionId = Extract<ResultActionId, 'export_private_backup' | 'export_redacted_share'>;
export type ProductionExportFile = LocalChartPrivateBackupFile | LocalChartRedactedShareFile;

export function buildProductionChartExport(
  action: ProductionExportActionId,
  repository: LocalChartRepository,
  exportedAt: string,
  options: Readonly<{ confirmedSensitiveExport?: boolean }> = {},
): ProductionExportFile {
  if (action === 'export_private_backup') {
    if (options.confirmedSensitiveExport !== true) {
      throw new Error('Private backup export requires explicit sensitive-data confirmation');
    }
    return buildLocalChartPrivateBackup(repository, exportedAt);
  }
  if (action === 'export_redacted_share') {
    return buildLocalChartRedactedShare(repository, exportedAt);
  }
  throw new Error(`Unsupported production export action ${String(action)}`);
}
